import { useMemo } from "react";
import { handleStagesBankMetrix } from "containers/services/data.transformers";
import { useAppContext } from "utils/context";

import Content from "./content";
import NationalCodeInput from "./form";
import Header from "./header";
import UserInfo from "./info";

const BankInfo = ({ data, ...props }) => {
  const { metrixInstance } = useAppContext();
  const baseInfoData = data.stages.filter(
    (item) => item.key === "BASE_INFO"
  )[0];

  useMemo(async () => {
    await handleStagesBankMetrix("BASE_INFO", metrixInstance);
  }, [props?.currentStage?.key]);

  return (
    <>
      <div className=" flex-col pt-12">
        <Header />
        <Content />
        <NationalCodeInput data={baseInfoData} {...props} />
        <UserInfo data={baseInfoData} />
      </div>
    </>
  );
};
export default BankInfo;
